"use client"

import { Card } from "antd"
import React, { useState, useEffect } from "react"

export default function LuxuryTemplate() {
  const [cart, setCart] = useState(() => {
    const savedCart = localStorage.getItem("cartObj");
    return savedCart ? JSON.parse(savedCart) : { items: [], total: 0, paid: 0, salesRepName: "" };
  });

  useEffect(() => {
    const intervalId = setInterval(() => {
      const savedCart = localStorage.getItem("cartObj");
      if (savedCart) {
        setCart(JSON.parse(savedCart));
      }
    }, 1000);

    return () => clearInterval(intervalId);
  }, []);

  return (
    <div
      style={{
        height: "100vh",
        background: "linear-gradient(to bottom right, #111827, #581C87, #000000)",
        overflow: "hidden",
      }}
    >
      <div style={{ height: "100%", display: "flex", flexDirection: "column" }}>
        {/* Header */}
        <div style={{ textAlign: "center" }}>
          <h1
            style={{
              fontSize: 25,
              fontFamily: "serif",
              color: "#D4AF37",
              marginBottom: 2,
            }}
          >
            Premium Experience
          </h1>
          <div
            style={{
              width: 128,
              height: 1,
              background: "linear-gradient(to right, transparent, #D4AF37, transparent)",
              margin: "0 auto",
            }}
          ></div>
        </div>

        {/* Main Content */}
        <div
          style={{
            flex: 1,
            display: "grid",
            gridTemplateColumns: "1fr",
            gap: 32,
          }}
          className="lg:grid-cols-3"
        >
          {/* Left - Ambiance */}
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              textAlign: "center",
            }}
          >
            <div
              style={{
                width: 80,
                height: 80,
                borderRadius: "50%",
                background: "linear-gradient(to bottom right, rgba(212,175,55,0.2), rgba(212,175,55,0.05))",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                marginBottom: 2,
                border: "1px solid rgba(212,175,55,0.3)",
              }}
            >
              <span style={{ fontSize: 40 }}>👑</span>
            </div>
            <h3
              style={{
                fontSize: 24,
                fontFamily: "serif",
                color: "#D4AF37",
              }}
            >
              Crafted Excellence
            </h3>
            <p
              style={{
                color: "#D1D5DB",
                fontWeight: 200,
                lineHeight: "1.5",
              }}
            >
              Every item prepared with the finest ingredients and utmost care for your distinguished taste.
            </p>
          </div>

          {/* Center - Order Display */}
          <div className="lg:col-span-2">
            <Card
              style={{
                height: "100%",
                background: "rgba(0,0,0,0.4)",
                border: "1px solid rgba(212,175,55,0.3)",
                backdropFilter: "blur(4px)",
              }}
              bodyStyle={{ height: "10%", display: "flex", flexDirection: "column" }}
            >
              <h2
                style={{
                  fontSize: 30,
                  fontFamily: "serif",
                  color: "#D4AF37",
                  textAlign: "center",
                }}
              >
                Your Selection
              </h2>

              {cart.items.length === 0 ? (
                <div
                  style={{
                    flex: 1,
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <div
                    style={{
                      width: 60,
                      height: 60,
                      borderRadius: "50%",
                      background: "rgba(212,175,55,0.1)",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      border: "1px solid rgba(212,175,55,0.2)",
                    }}
                  >
                    <span style={{ fontSize: 40, color: "#D4AF37" }}>✨</span>
                  </div>
                  <p style={{ fontSize: 20, color: "#D1D5DB", fontWeight: 300 }}>
                    Awaiting your selection
                  </p>
                </div>
              ) : (
                <div style={{ flex: 1, display: "flex", flexDirection: "column" }}>
                  <div
                    style={{
                      flex: 1,
                      display: "flex",
                      flexDirection: "column",
                      gap: 5,
                      overflowY: "auto",
                      maxHeight: "40vh", // Set a max height to trigger scrolling
                      scrollbarWidth: "thin", // For Firefox
                      scrollbarColor: "#D4AF37 rgba(212,175,55,0.2)", // For Firefox
                    }}
                    className="custom-scrollbar" // For Webkit browsers
                  >
                    {cart.items.map((item) => (
                      <div
                        key={item.id}
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: 24,
                          padding: 16,
                          background: "rgba(255,255,255,0.05)",
                          borderRadius: 8,
                          border: "1px solid rgba(212,175,55,0.2)",
                        }}
                      >
                        <img
                          src={item.image || "/placeholder.svg?height=80&width=80"}
                          alt={item.name}
                          style={{
                            width: 80,
                            height: 80,
                            objectFit: "cover",
                            borderRadius: 8,
                            border: "1px solid rgba(212,175,55,0.3)",
                          }}
                        />
                        <div style={{ flex: 1 }}>
                          <h3
                            style={{
                              fontSize: 20,
                              fontFamily: "serif",
                              color: "#FFFFFF",
                              marginBottom: 4,
                            }}
                          >
                            {item.name}
                          </h3>
                          <p style={{ color: "#9CA3AF" }}>
                            Quantity: {item.quantity}
                          </p>
                        </div>
                        <div style={{ textAlign: "right" }}>
                          <p
                            style={{
                              fontSize: 24,
                              fontFamily: "serif",
                              color: "#D4AF37",
                            }}
                          >
                            ${(item.price * item.quantity).toFixed(2)}
                          </p>
                        </div>
                      </div>
                    ))}
                  </div>

                  <div
                    style={{
                      //marginTop: 32,
                      //paddingTop: 24,
                      borderTop: "1px solid rgba(212,175,55,0.3)",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                      }}
                    >
                      <span
                        style={{
                          fontSize: 24,
                          fontFamily: "serif",
                          color: "#FFFFFF",
                        }}
                      >
                        Total Excellence
                      </span>
                      <span
                        style={{
                          fontSize: 20,
                          fontFamily: "serif",
                          color: "#D4AF37",
                        }}
                      >
                        ${cart.total.toFixed(2)}
                      </span>
                    </div>
                  </div>
                </div>
              )}
            </Card>
          </div>
        </div>
      </div>

      {/* Custom Scrollbar Styles */}
      <style jsx global>{`
        .custom-scrollbar::-webkit-scrollbar {
          width: 8px;
        }
        .custom-scrollbar::-webkit-scrollbar-track {
          background: rgba(212,175,55,0.2);
          border-radius: 4px;
        }
        .custom-scrollbar::-webkit-scrollbar-thumb {
          background: #D4AF37;
          border-radius: 4px;
        }
        .custom-scrollbar::-webkit-scrollbar-thumb:hover {
          background: #e6c465;
        }
      `}</style>
    </div>
  )
}